function t(a, e) {
  return a.has(e);
}
export {
  t as default
};
